import { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Bookings/Table";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import SummaryCard from "../../Components/Bookings/SummaryCard";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import NotFoundModel from "../../Components/NotFoundModel";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import SideModal from "../../Components/SideModal";
import SelectProperty from "../../Components/AddTenant/SelectProperty";
import { FiCopy, FiShare2 } from "react-icons/fi";
import ViewDetails from "../../Components/Bookings/ViewDetails";
import SearchFilterBox from "../../Components/SearchFilterBox";
import { toast } from "react-toastify";
import { handleCopy } from "../../helpers";
import AddBooking from "../../Components/Bookings/AddBooking";
import BookingsAnalyticsSideModal from "../../Components/Bookings/AnalyticsSideModal";
import { IoAnalytics } from "react-icons/io5";
import moment from "moment";
import DateRange from "../../Components/DateRange";
import AddBookingNew from "../../Components/Bookings/AddBookingNew";

const BookingList = () => {
  const searchOptions = [
    { label: "Name", value: 1 },
    { label: "Mobile", value: 2 },
    { label: "App No.", value: 3 },
    // { label: "Payment Mode", value: 3 },
  ];
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty,
  );

  const properties = useSelector((state) => state.PropertyReducer.property);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  //const [addTenant, setAddTenant] = useState(false);
  const [isSelectProperty, setIsSelectProperty] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [filter, setFilter] = useState(user?.defaultTenantFilter || "");
  const [filterVal, setFilterVal] = useState("");
  const [isViewDetails, setIsViewDetails] = useState(false);
  const [isAddBooking, setIsAddBooking] = useState(false);

  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const TENANT_TIME_SCOPE = {
    THIS_MONTH: "THIS_MONTH",
    NEXT_MONTH: "NEXT_MONTH",
    ALL: "ALL",
  };

  const ACTIVE_TENANT_SCOPE = {
    THIS_MONTH: "THIS_MONTH",
    ALL: "ALL",
  };


  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
    subTitle: "",
  });

  const [apiData, setApiData] = useState();
  const [staffData, setStaffData] = useState([]);
  const [summaryData, setSummaryData] = useState({
    totalTenants: 0,
    newTenants: 0,
    verified: 0,
    moveIn: 0,
    moveOut: 0,
    unVerified: 0,
    appNotInstalled: 0,
  });

  const [summarySelectedKey, setSummarySelectedKey] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(property);
  const [isViewNotes, setIsViewNotes] = useState(false);
  const [encryptedId, setEncryptedId] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);
  const [isAssigningProperty, setIsAssigningProperty] = useState(false);
  const [isAnalyticsModalOpen, setIsAnalyticsModalOpen] = useState(false);
  //const [selectedTenantForAssignment, setSelectedTenantForAssignment] = useState(null);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [startDate, setStartDate] = useState(
    sessionStorage.getItem("tenant_movedout_startDate") ||
    moment().subtract(6, 'months').startOf("month").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    sessionStorage.getItem("tenant_movedout_endDate") ||
    moment().format("YYYY-MM-DD")
  );
  const query = `startDate=${startDate}&endDate=${endDate}&propId=${selectedProperty?.id}&s=${searchQuery}&t=${filterType}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/bookings/list/for/client?${query}`,
      // `${Config.apiUrl}/bookings/list/for/client`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setApiData(res?.data);
      setSummaryData(res?.summary);
      setEncryptedId(res?.encryptedId)
      setIsFocused(true);
    }
  };

  const getError = () => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
  };
  const handleDownloadDetails = async (tenantId) => {
    if (!tenantId) {
      console.error('Tenant ID is required');
      return;
    }

    setIsDownloading(true);
    try {
      const response = await axios.get(
        `${Config.apiUrl}/bookings/download/tenant/profile?tenantId=${tenantId}`,
        {
          headers: {
            authorization: "Bearer" + " " + user.token,
            "Content-Type": "application/json",
          },
        }
      );

      // Check if the response contains a download link
      if (response.data && response.data.downloadUrl) {
        // Open the download link in a new tab or trigger download
        window.open(response.data.downloadUrl, '_blank');
      } else if (response.data && response.data.url) {
        window.open(response.data.url, '_blank');
      } else if (response.data && response.data.link) {
        window.open(response.data.link, '_blank');
      } else {
        // If the response is a direct URL string
        const downloadUrl = typeof response.data === 'string' ? response.data : response.data?.data?.downloadUrl || response.data?.data?.url;
        if (downloadUrl) {
          window.open(downloadUrl, '_blank');
        } else {
          // If it's a blob or file data, handle it as a file download
          const blob = new Blob([response.data], {
            type: response.headers['content-type'] || 'application/pdf'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `tenant_profile_${tenantId}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      }
    } catch (error) {
      console.error('Error downloading tenant details:', error);
      toast.error('Failed to download tenant details. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  // Handle Assign Property from View Details
  const handleAssignProperty = (data) => {
    setSelectedTenant(data);
    setIsViewDetails(false);
    setIsSelectProperty(true);
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
    return () => clearTimeout(handler);
  }, [filterType, searchQuery, startDate, endDate, selectedProperty, getListMutate]);

  useEffect(() => {
    if (property && !selectedProperty) {
      setSelectedProperty(property);
    }
  }, [property, selectedProperty]);

  // useEffect(() => {
  //   if (location?.id) {
  //     sessionStorage.removeItem("booking_active_page");

  //     setFilter("L");
  //     setFilterVal(location.id);

  //     setActiveFilter({
  //       value: "L",
  //       filterVal: location.id,
  //       label: location.name || "Location",
  //       title: "Location",
  //       subTitle: "Location",
  //     });

  //     setSelectedProperty({
  //       id: 0,
  //       name: "All Properties",
  //       gId: "KIPINN",
  //       type: 0,
  //       tenantPreference: 3,
  //       tenantCount: 0,
  //     });
  //   }
  // }, [location]);


  const handlePropertySelect = (property) => {
    sessionStorage.removeItem("booking_active_page");
    // if (filter === "L") {
    //   setFilter("");
    //   setFilterVal("");
    //   setFilterVal("");
    //   setActiveFilter({
    //     value: "",
    //     filterVal: "",
    //     label: "",
    //     title: "",
    //     subTitle: "",
    //   });
    // }
    setSelectedProperty(property);
  };

  const panelRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!isFilterOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setIsFilterOpen(false);
    };
    const onClickOutside = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setIsFilterOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [isFilterOpen]);

  // const onApplyFilter = (
  //   value,
  //   label,
  //   title,
  //   subTitle,
  //   isBookedBy = false,
  //   extraValue = null,
  // ) => {
  //   sessionStorage.removeItem("booking_active_page");
  //   setFilterSource("dropdown");
  //   setSummarySelectedKey(null);

  //   if (isBookedBy) {
  //     setFilter("BY");
  //     setFilterVal(extraValue ? extraValue.join(",") : "");
  //     setActiveFilter({
  //       value: extraValue ? extraValue.join(",") : "",
  //       filterVal: extraValue ? extraValue.join(",") : "",
  //       label,
  //       title,
  //       subTitle,
  //     });
  //   } else if (value === "L") {
  //     setFilter("L");
  //     setFilterVal(extraValue ? extraValue : "");
  //     setActiveFilter({
  //       value: "L",
  //       filterVal: extraValue ? extraValue : "",
  //       label,
  //       title,
  //       subTitle,
  //     });
  //     setSelectedProperty({ id: 0, name: "All Properties", gId: "KIPINN", type: 0, tenantPreference: 3, tenantCount: 634, tenantPreference: 3, type: 0 });
  //   } else {
  //     setFilter(value);
  //     setFilterVal("");
  //     setActiveFilter({
  //       value,
  //       filterVal: "",
  //       label,
  //       title,
  //       subTitle,
  //     });
  //   }

  //   setIsFilterOpen(false);
  // };

  // const onSummaryBoxClick = (value) => {
  //   sessionStorage.removeItem("booking_active_page");
  //   setFilterSource("summary");
  //   setSummarySelectedKey(value);
  //   setFilter(value);
  //   setFilterVal("");
  //   setActiveFilter({ value: "", filterVal: "", label: "", title: "", subTitle: "" });
  //   setIsFilterOpen(false);
  // };

  // const clearFilter = () => {
  //   //setFilter("");
  //   setFilter(user?.defaultTenantFilter || "");
  //   setFilterVal("");
  //   setActiveFilter({
  //     value: "",
  //     filterVal: "",
  //     label: "",
  //     title: "",
  //     subTitle: "",
  //   });
  //   setFilterSource(null);
  //   setSummarySelectedKey(null);
  //   setIsFilterOpen(false);
  // };

  // const handleFilterClose = () => {
  //   setIsFilterOpen(false);
  // };

  const handleSelectPropertyClose = () => {
    setIsSelectProperty(false);
  };

  const handleShare = (encryptedId) => {
    const url = `${Config.bookingShareUrl}/${encryptedId}`;
    const message = `Check out this property:\n${url}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`);
  };

  const handleFilterChange = (values) => {
    sessionStorage.removeItem("booking_active_page");
    setActiveFilter("");
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("");
  };

  const handleRefresh = () => {
    setIsSelectProperty(false);
    getListMutate();
  };

  //------- Add Booking -------

  const AddBookingFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/bookings/add/without/bed`, values, {
      // return await axios.post(`${Config.apiUrl}/bookings/add/confirmed/tenant`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onAddBookingSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      // toast.success(data?.data?.msg || "Success");
      setIsAddBooking(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddBookingError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addBookingLoading, mutate: addBookingMutate } =
    useMutation(AddBookingFunction, {
      onSuccess: onAddBookingSuccess,
      onError: onAddBookingError,
    });

  const handleClose = () => {
    setIsAnalyticsModalOpen(false)
  }
  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            {"Bookings"}
            <Underline />
          </BoxTitle>
          <div className="flex items-center gap-3">
            {/* Secondary Actions */}
            <div className="flex h-10 items-center rounded-lg border border-gray-200 overflow-hidden bg-white">
              <button
                onClick={() => handleCopy(`${Config.bookingShareUrl}/${encryptedId}`)}
                className="flex h-full items-center gap-2 px-4 text-sm text-gray-700 hover:bg-gray-50 border-r border-gray-200"
              >
                <FiCopy size={16} />
                Copy Link
              </button>

              <button
                onClick={() => handleShare(encryptedId)}
                className="flex h-full items-center gap-2 px-4 text-sm text-gray-700 hover:bg-gray-50"
              >
                <FiShare2 size={16} />
                Share
              </button>
            </div>

            <ApplyBtn
              type="button"
              onClick={() => setIsAddBooking(true)}
              className="h-10"
            >
              Add Booking
            </ApplyBtn>
          </div>
        </BoxHead>

        {/* <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
          <FilterModal
            setIsFilterOpen={setIsFilterOpen}
            onApplyFilter={onApplyFilter}
            selectedData={selectedData}
            handleClose={handleFilterClose}
            staffData={staffData}
            currentFilter={filter}
            handleClearFilters={clearFilter}
            currentFilterVal={filterVal}
            setSelectedLocationId={setSelectedLocationId}
            selectedLocationId={selectedLocationId}
          />
        </SideModal> */}

        {/* <PaymentLinkModal
          isOpen={showPaymentLinkModal}
          onClose={closePaymentModal}
          paymentData={paymentData}
        /> */}

        {/* {showTenantModal && (
          <SideModal
            isOpen={showTenantModal}
            onClose={closeTenantModal}
          >
            <TenantDetailsModal
              isLoading={isTenantDetailsLoading}
              tenant={selectedTenant}
              onClose={closeTenantModal}
              onNext={handleNext}
              onPrevious={handlePrevious}
              hasNext={hasNext}
              hasPrevious={hasPrevious}
              loadPaymentLinkModal={
                loadPaymentLinkModal
              }
              loadingId={loadingId}
            />
          </SideModal>
        )} */}

        <SideModal
          isOpen={isSelectProperty}
          onClose={() => setIsSelectProperty(false)}
        >
          <SelectProperty
            setIsSelectProperty={setIsSelectProperty}
            isSelectProperty={isSelectProperty}
            handleClose={handleSelectPropertyClose}
            getListMutate={handleRefresh}
            selectedTenant={selectedTenant}
            source="booking"
          />
        </SideModal>

        <SideModal
          isOpen={isAnalyticsModalOpen}
          onClose={() => setIsAnalyticsModalOpen(false)}
        >
          <BookingsAnalyticsSideModal
            setIsAnalyticsModalOpen={setIsAnalyticsModalOpen}
            isAnalyticsModalOpen={isAnalyticsModalOpen}
            handleClose={handleClose}
            token={user.token}
          />
        </SideModal>

        <SideModal
          isOpen={isViewDetails}
          onClose={() => setIsViewDetails(false)}
        >
          <ViewDetails
            setIsViewDetails={setIsViewDetails}
            selectedData={selectedData}
            onDownloadDetails={handleDownloadDetails}
            isDownloading={isDownloading}
            onAssignProperty={handleAssignProperty}
            isAssigningProperty={isAssigningProperty}
            showAssignButton={true}
          />
        </SideModal>

        <SideModal
          isOpen={isAddBooking}
          onClose={() => setIsAddBooking(false)}
        >
          <AddBookingNew
            handleClose={() => setIsAddBooking(false)}
            addBookingLoading={addBookingLoading}
            addBookingMutate={addBookingMutate}
          />
        </SideModal>

        {(isLoading || isRefetching) && (
          <SummarySkeletonLoading count={4} />
        )}

        {!error && !isLoading && isFocused && summaryData && (
          <SummaryCard
            summaryData={summaryData}
            // onClick={onSummaryBoxClick}
            selectedKey={summarySelectedKey}
          />
        )}

        <FilterTableWrapper>
          <FilterWrapper>
            {/* {isFocused && data && ( */}
            <>
              {/* <div className="flex items-center justify-between w-full gap-3"> */}
              <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
                <SearchFilterBox
                  options={searchOptions}
                  handleFilterChange={handleFilterChange}
                  handleClearFilters={handleClearFilters}
                  className="flex-1 min-w-0"
                />
                <DateRange
                  mode={"default"}
                  submitHandler={submitHandler}
                  defaultLabel={
                    moment(startDate).format("DD MMM yyyy") +
                    " - " +
                    moment(endDate).format("DD MMM yyyy")
                  }
                />
              </div>


              <div className="flex gap-2 justify-end items-center ml-auto">
                <PropertiesFilterDropdown
                  properties={properties}
                  selectedProperty={selectedProperty}
                  onPropertySelect={handlePropertySelect}
                  placeholder="Select Property"
                  className="min-w-[200px] w-full md:w-[220px]"
                />
                <AnalyticsBtn
                  type="button"
                  onClick={() => setIsAnalyticsModalOpen(true)}
                >
                  <IoAnalytics size={14} color="#9CA3AF" />
                </AnalyticsBtn>
              </div>
            </>
            {/* )} */}
          </FilterWrapper>
          {!error && !isLoading && apiData && (
            <TableWrapper>
              <Table
                //apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                apiData={error ? [] : apiData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                isMovingOut={filter}
                setIsViewNotes={setIsViewNotes}
                setIsViewDetails={setIsViewDetails}
                handleAssignProperty={handleAssignProperty}
              // handleOpenTenantModal={openTenantModal}
              />
              {(error || apiData?.length === 0) && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
        </FilterTableWrapper>


        {(isLoading || isRefetching) && <Loading />}

        {error && !isLoading && <NotFoundModel />}
      </BoxContainer>
    </>
  );
};


const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-hover-color h-full py-2.5 text-sm`;
const AnalyticsBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
export default BookingList;
